module.exports = __webpack_public_path__ + "e4572bca701f63e33ccf07b5cac9c48a.MP3";